import {
  allIconsSelected,
  getSelectedIconIds,
  hasMultipleSelectedIcons
} from '~/selectors/CanvasSelectors';
import {metrics} from '~/vendor/metrics';

export default function selectionAnalyzer(store) {
  return next => action => {
    const initialState = store.getState();
    const initialSelectionCount = getSelectedIconIds(initialState).length;

    const result = next(action);
    const nextState = store.getState();

    const nextSelectionCount = getSelectedIconIds(nextState).length;
    const isSelectionDifferent = initialSelectionCount !== nextSelectionCount;

    if (
      hasMultipleSelectedIcons(nextState) &&
      isSelectionDifferent &&
      allIconsSelected(nextState)
    ) {
      metrics.pageViewTag('/ndx/multiselect');
    }
    return result;
  };
}
